import BaseTabs, { IBaseTabOptions } from '@components/base/BaseTabs';
import BaseSlider, { IBaseSliderOptions } from '@components/base/BaseSlider';

export default class ContentBoxFrame {
	private readonly element: HTMLElement;

	private tabs!: BaseTabs;

	private slider!: BaseSlider;

	private currentSection?: string;

	public constructor(element: HTMLElement) {
		this.element = element;

		const optionsString = this.element.getAttribute('data-options');
		const domOptions: IContentBoxFrameOptions = optionsString ? JSON.parse(optionsString) : null;

		this.init(domOptions);
	}

	private init(options?: IContentBoxFrameOptions): void {
		this.changeSection = this.changeSection.bind(this);

		if (options && options.initialSection) {
			this.currentSection = options.initialSection;
		}

		this.initMqManager();
	}

	private changeSection(event: CustomEventInit): void {
		this.currentSection = event.detail.currentTab || event.detail.selectedElement.getAttribute('data-tabs-pane');
	}

	private initMqManager(): void {
		const mql = window.matchMedia('(max-width: 980px)'); // TODO: get breakpoint from SCSS?

		const checkMql = (): void => {
			const sliderOptions: IBaseSliderOptions = {
				flickityOptions: { initialIndex: this.idToFlickityIndex(this.currentSection) }
			};
			const tabsOptions: IBaseTabOptions = { initialTab: this.currentSection };

			if (mql.matches) {
				if (this.tabs) {
					this.tabs.destroy();
					this.tabs.getElement().removeEventListener(BaseTabs.events.TABS_CHANGED, this.changeSection);
				}
				this.slider = new BaseSlider(this.element, sliderOptions);
				this.slider.getElement().addEventListener(BaseSlider.events.SLIDER_CHANGED, this.changeSection);
			} else {
				if (this.slider) {
					this.slider.destroy();
					this.slider.getElement().removeEventListener(BaseSlider.events.SLIDER_CHANGED, this.changeSection);
				}
				this.tabs = new BaseTabs(this.element, tabsOptions);
				this.tabs.getElement().addEventListener(BaseTabs.events.TABS_CHANGED, this.changeSection);
			}
		};

		if (mql.addEventListener) {
			mql.addEventListener('change', checkMql);
		} else {
			// Safari only supports the old syntax
			mql.addListener(checkMql);
		}

		checkMql();
	}

	// flickity only takes index for initial slides, no id
	private idToFlickityIndex(id: string | undefined | null): number {
		return (
			Array.from(this.element.querySelectorAll('[data-slides-wrapper] > *')).findIndex((item): boolean => {
				const idAttribute = item.getAttribute('data-tabs-pane');
				return idAttribute === id;
			}) || 0
		);
	}
}

interface IContentBoxFrameOptions {
	initialSection?: string;
}
